import React, {useState, useMemo} from "react"
import {useParams, useNavigate} from "react-router-dom"
import useAuth from "auth/useAuth"
import useRescuers from "hooks/useRescuers"
import LittleSpinner from "components/LittleSpinner"
import Rescuer from "components/Rescuer"
import RescuerSearchInfo from "./RescuerSearchInfo"
import RescuerSearchTags from "./RescuerSearchTags"
import "./RescuerSearch.css"



export default function RescuerSearch() {

    const {auth, API} = useAuth()
    const {data: rescuers, filter} = useRescuers()
    const {q} = useParams()
    const [query, setQuery] = useState(decodeURI(q || ""))
    const [aiLoading, setAiLoading] = useState(false)
    const navigate = useNavigate()

    const search = (q) => {
        navigate(encodeURI(`/rescuers/${q}`))
        setQuery(q)
    }

    
    const results = useMemo(() => {
        return filter(query)
    }, [rescuers, query, filter])
    
    
    const addTag = (tag) => {
        const t = "tag:" + tag
        if (!query.includes(t)) {
            const newQuery = query + " " + t
            search(newQuery.trim())
        }
    }
    
    const formatRescuerCount = (num) => {
        if (num === 0)
            return "Nema rezultata"
        if (num >= 5 && num <= 20)
            return num + " spasilaca"
            
        const mod = num % 10
        if (mod === 1)
            return num + " spasilac"
        if ([2, 3, 4].includes(mod))
            return num + " spasioca"
        return num + " spasilaca"
    }
    
    const formatField = (value) => {
        if (!value) return ''
        if (Array.isArray(value)) return `"${value.join(', ')}"`
        return `"${value}"`
    }
    
    const generateCSV = () => {
        const columns = ['gss_id', 'given_name', 'family_name', 'nickname', 'birthdate', 'email', 'phone_number', 'address', 'city', 'station', 'pss_id', 'ski', 'coef', 'tags']
        let data = [columns]
        for (const rescuer of results.length > 0 ? results : rescuers) {
            if (!rescuer.gss_id) continue
            let row = columns.map(column => formatField(rescuer[column]))
            data.push(row)
        }
        const csvContent = data.map(row => row.join(',')).join('\n')
        const blob = new Blob([csvContent], { type: 'text/csv' })      
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)  
        link.download = q ? `rescuers.${q}.csv`.replaceAll(' ', '.').replaceAll(':', '.') : `rescuers.csv`
        link.click()
    }
    
    
    const aiSearch = () => {
        setAiLoading(true)
        auth(API.rescuersSearchGet, {q}).then(response => {
            console.log("AI", response.data)
            search(response.data)
            setAiLoading(false)
        }).catch(error => {
            console.log("AI error", error)
            setAiLoading(false)
        })
    }
    

    return <div id="rescuers" className="search-tab-content">
            
            <div className="search-box shadow white">
                <input type="text" value={query} onChange={e => search(e.target.value)} placeholder="Pretraga spasilaca..." onKeyDown={e => {if (e.key === "Enter") aiSearch()}}/>
                {query && <button className="inline" onClick={event => search("")} title="Obriši pretragu" aria-label="Obriši pretragu"><i className="fa-solid fa-xmark"/></button>}
                {aiLoading ? <LittleSpinner/>
                           : <button className="inline" onClick={aiSearch} title="AI pretraga" aria-label="AI pretraga"><i className="fa-solid fa-wand-magic-sparkles"/></button>}
                <button className="inline" onClick={generateCSV} title="Preuzmi CSV" aria-label="Preuzmi CSV"><i className="fa-solid fa-download"/></button>
            </div>
            
            {results?.length > 0 ? <>
                <div className="result-count">{formatRescuerCount(results.length)}</div>
                <div id="search-results">
                    {results.map((rescuer, i) => <Rescuer key={rescuer.username} rescuer={rescuer} onClick="profile"/>)}
                </div>
            </> : <RescuerSearchInfo search={search} rescuers={rescuers}/>}
            
            
            <hr/>
            
            <RescuerSearchTags addTag={addTag}/>

        </div>
    
}